(function () {
  var CARD_PRICING = '[data-monthlees-card-pricing]';
  var MEMBER_VISIBLE = '[data-monthlees-member-visible]';
  var TRIGGER_WRAP = '[data-mmp-trigger-wrap]';
  var RESOLVED_PRICE = '[data-mmp-resolved-price]';
  var GUEST_PRICE = '[data-monthlees-guest-price]';
  var ACTIVE_MEMBER = '.monthlees-membership-message--active';

  function boldPricing() {
    return window.MonthleesBoldPricing;
  }

  function isPersistentActiveMember() {
    if (document.body && document.body.getAttribute('data-monthlees-persistent-member') === 'true') {
      return true;
    }

    return !!document.querySelector(ACTIVE_MEMBER);
  }

  function isMembershipCartPreview() {
    if (isPersistentActiveMember()) return false;

    return (
      document.body &&
      document.body.getAttribute('data-monthlees-membership-in-cart') === 'true'
    );
  }

  function getCartLineUnitCents(variantId) {
    if (!variantId || !window.MonthleesCartVariantPrices) return 0;
    var prices = window.MonthleesCartVariantPrices;
    return prices[variantId] || prices[String(variantId)] || 0;
  }

  function getMoneyFormat(container) {
    if (container && container.getAttribute('data-money-format')) {
      return container.getAttribute('data-money-format');
    }
    if (document.body && document.body.getAttribute('data-monthlees-money-format')) {
      return document.body.getAttribute('data-monthlees-money-format');
    }
    var config = window.MonthleesMemberPricingConfig || {};
    return config.moneyFormat || '${{amount}}';
  }

  function setTriggerVisible(visible, show) {
    var triggerWrap = visible.querySelector(TRIGGER_WRAP);
    var resolved = visible.querySelector(RESOLVED_PRICE);
    if (triggerWrap) {
      if (show) triggerWrap.removeAttribute('hidden');
      else triggerWrap.setAttribute('hidden', '');
    }
    if (resolved && show) {
      resolved.setAttribute('hidden', '');
    }
  }

  function setResolvedPrice(visible, priceText) {
    var triggerWrap = visible.querySelector(TRIGGER_WRAP);
    var resolved = visible.querySelector(RESOLVED_PRICE);
    if (triggerWrap) triggerWrap.setAttribute('hidden', '');
    if (resolved) {
      resolved.textContent = priceText;
      resolved.removeAttribute('hidden');
    }
  }

  function clearResolvedPrice(visible) {
    var resolved = visible.querySelector(RESOLVED_PRICE);
    if (resolved) {
      resolved.textContent = '';
      resolved.setAttribute('hidden', '');
    }
  }

  function setResolvedState(container, visible, resolved) {
    if (resolved) {
      visible.classList.add('monthlees-product-card__member-visible--resolved');
      visible.classList.remove('monthlees-product-card__member-placeholder');
      container.classList.add('monthlees-product-card__pricing--member-resolved');
    } else {
      visible.classList.remove('monthlees-product-card__member-visible--resolved');
      visible.classList.add('monthlees-product-card__member-placeholder');
      container.classList.remove('monthlees-product-card__pricing--member-resolved');
    }
  }

  function resolveCardMemberPrice(container, guest) {
    var bold = boldPricing();
    if (!bold) return null;

    var variantId = guest.getAttribute('data-variant-id');
    var guestCents = parseInt(guest.getAttribute('data-guest-cents'), 10) || 0;
    var moneyFormat = getMoneyFormat(container);
    var isPersistent = isPersistentActiveMember();
    var isCartPreview = isMembershipCartPreview();
    var cartCents = isPersistent || isCartPreview ? getCartLineUnitCents(variantId) : 0;

    // Always allow metafield / index / ratio preview on product cards so member
    // prices are visible to every visitor (not gated behind "View member price").
    return bold.resolveMemberPrice(container, {
      variantId: variantId,
      guestCents: guestCents,
      moneyFormat: moneyFormat,
      cartCents: cartCents,
      allowPreview: true,
    });
  }

  function syncCardPricing(container) {
    var visible = container.querySelector(MEMBER_VISIBLE);
    var guest = container.querySelector(GUEST_PRICE);
    if (!visible || !guest) return;

    var resolved = resolveCardMemberPrice(container, guest);
    var hasPrice = resolved && resolved.boldApplied && resolved.text;

    // Cards never show the modal trigger — always surface the member price when known.
    setTriggerVisible(visible, false);

    if (hasPrice) {
      setResolvedPrice(visible, resolved.text);
      setResolvedState(container, visible, true);
      return;
    }

    var existing = visible.querySelector(RESOLVED_PRICE);
    if (existing && existing.textContent && existing.textContent.trim()) {
      existing.removeAttribute('hidden');
      setResolvedState(container, visible, true);
      return;
    }

    clearResolvedPrice(visible);
    setResolvedState(container, visible, false);
  }

  function observeCard(container) {
    var target = container.querySelector('[data-bold-price-target="member"]');
    if (!target) return;

    new MutationObserver(function () {
      syncCardPricing(container);
    }).observe(target, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    syncCardPricing(container);
  }

  function syncAllCards() {
    var bold = boldPricing();
    var run = function () {
      document.querySelectorAll(CARD_PRICING).forEach(syncCardPricing);
    };

    if (bold && typeof bold.loadMemberIndex === 'function') {
      bold.loadMemberIndex().then(run).catch(run);
    } else {
      run();
    }
  }

  function init() {
    document.querySelectorAll(CARD_PRICING).forEach(observeCard);

    [200, 500, 1000, 2000, 3000, 5000, 8000].forEach(function (ms) {
      setTimeout(syncAllCards, ms);
    });

    document.addEventListener('monthlees:cart-membership-toggle', function () {
      syncAllCards();
    });
    document.addEventListener('monthlees:cart-updated', syncAllCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
